export enum StickerFormatEnum {
  Video = 'VIDEO',
  Audio = 'AUDIO',
  Image = 'PHOTO',
  Upload = 'IMAGE'
}
